import _ from 'lodash'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import { useLinkGenerator } from '../../hooks/useLinkGenerator'
import { Button } from '../Button'
import { Dropdown } from '../Dropdown'
import { Image } from '../Image'
import { Menu, MenuItem } from '../Menu'
import { Text } from '../Text'
import { themeColor } from '../theme'

import { NavPillsItem, NavPillsProps } from './NavPills'

const StyledDropdown = styled(Dropdown)`
  width: 100%;
  img {
    transform: rotate(90deg);
  }

  &.opened {
    img {
      transform: rotate(-90deg);
    }
  }

  .ant-dropdown-menu {
    background-color: ${themeColor('primary')} !important;
  }
`

const StyledButton = styled(Button)`
  width: 100%;
`

export const ResponsiveNavPills = ({ items }: NavPillsProps) => {
  const { generateRoute } = useLinkGenerator()
  const navigate = useNavigate()
  const inactiveItems = _.filter<NavPillsItem>(items, item => !item.active)

  const menu = (
    <Menu variant="primary">
      {_.map(inactiveItems, (item, i) => (
        <MenuItem
          variant="primary"
          key={i}
          onClick={() => {
            navigate(generateRoute(item.page))
          }}
        >
          {item.text}
        </MenuItem>
      ))}
    </Menu>
  )

  const text = (
    <Text color="textPrimaryInverse" fontWeight="bold" block display="flex" flex="1 1 auto" justifyItems="left">
      {_.find(items, 'active')?.text}
    </Text>
  )

  return _.isEmpty(inactiveItems) ? (
    <StyledButton variant="primary">{text}</StyledButton>
  ) : (
    <StyledDropdown dropdownRender={() => menu} trigger={['hover', 'click']} openClassName="opened">
      <Button
        variant="primary"
        icon={<Image alt="arrow-down" type="arrowRightWhite" width="24px" height="24px" />}
        iconPlacement="right"
      >
        {text}
      </Button>
    </StyledDropdown>
  )
}
